var _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCm = function SvgCm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 640 480"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#007a5e",
    d: "M0 0h213.3v480H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ce1126",
    d: "M213.3 0h213.4v480H213.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "M426.7 0H640v480H426.7z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fcd116",
    transform: "translate(320 240)scale(7.1111)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cm_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    id: "cm_svg__a",
    d: "M0-8-2.5-.4 1.3.9z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cm_svg__a",
    width: "100%",
    height: "100%",
    transform: "scale(-1 1)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cm_svg__b",
    width: "100%",
    height: "100%",
    transform: "rotate(72)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cm_svg__b",
    width: "100%",
    height: "100%",
    transform: "rotate(144)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cm_svg__b",
    width: "100%",
    height: "100%",
    transform: "rotate(-144)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cm_svg__b",
    width: "100%",
    height: "100%",
    transform: "rotate(-72)"
  }))));
};
export default SvgCm;